import { render, staticRenderFns } from "./AdminWebsiteText.vue?vue&type=template&id=35cbe90d&"
import script from "./AdminWebsiteText.vue?vue&type=script&lang=js&"
export * from "./AdminWebsiteText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports